<template>
  <div>
    <app-mask-field
      v-bind="$attrs"
      hide-details="auto"
      v-on="$listeners"
      dense
      append-outer-icon="mdi-magnify"
      label="CEP"
      @input="handleInput($event)"
      :loading="loading"
      mask="#####-###"
      @click:append-outer="handleCitySearch()"
    />
    <SearchCity
      ref="SearchCity"
      @input="handleInput($event)"
      :item-value="(val) => val.postal_code"
    />
  </div>
</template>

<script>
import axios from "axios";
import SearchCity from "@/components/app/forms/SearchCity";

export default {
  components: {
    SearchCity,
  },
  data: () => ({
    loading: false,
    cep: "",
  }),

  methods: {
    handleInput(cep) {
      cep = cep.replace(/\D/g, "");

      if (cep.length == 8) {
        this.searchCep(cep);
      }
    },

    async searchCep(cep) {
      this.loading = true;

      try {
        const address = await this.fetchFromViaCep(cep);

        this.$emit("address", address);
      } catch (viaCepError) {
        console.warn("Erro no ViaCEP, tentando OpenCEP:", viaCepError.message);

        try {
          const address = await this.fetchFromOpenCep(cep);

          this.$emit("address", address);
        } catch (openCepError) {
          console.error("Erro ao buscar CEP em ambas APIs:", openCepError);
        }
      }

      this.loading = false;
    },

    async fetchFromViaCep(cep) {
      const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);

      if (response.data.erro) {
        throw new Error("CEP não encontrado no ViaCEP");
      }

      return response.data;
    },

    async fetchFromOpenCep(cep) {
      const response = await axios.get(`https://opencep.com/v1/${cep}.json`);

      return response.data;
    },

    handleCitySearch() {
      this.$refs.SearchCity.open();
    },
  },
};
</script>
